import { Flex } from '@withjoy/joykit';
import { useStationeryProductPricingContext } from '../utils/useStationeryProductPricingContext';
import { AttributeSelector } from './AttributeSelector';
import React from 'react';
import { useRegisterAttributeLinks } from '../utils/state/state.mapping';
import { useLinkStateToDraftProductMetadata } from '../utils/useLinkStateToDraftProductMetadata';
import { Attribute } from '../product.types';
import { useProductAttributes } from '../useProductAttributes';

type AttributesForStepProps = {
  step: string;
  isPDP?: boolean;
};

const isNotNull = (input: unknown): input is Attribute => {
  return !!input;
};

const matchesStepFilter = (input: Attribute, stepFilter?: string): boolean => {
  if (!stepFilter) {
    return true;
  }

  return input.step === stepFilter;
};

export const AttributesForStep = (props: AttributesForStepProps) => {
  const { activeProduct, priceCalculator, attributeStates } = useStationeryProductPricingContext();
  const { getAttribute, getFullState, addAttribute } = attributeStates;
  const activeAttributeIds = activeProduct.attributes.map(attr => attr.attributeId);
  const attributes = useProductAttributes();

  useRegisterAttributeLinks(addAttribute, activeProduct);
  useLinkStateToDraftProductMetadata(attributeStates);

  // Convert to UI mappings, and sort.
  const asUIConfigs = activeAttributeIds
    .map(attributeId => attributes.find(attr => attr.attributeId === attributeId))
    .filter(isNotNull)
    .filter(attr => matchesStepFilter(attr, props.step))
    .sort((a, b) => {
      return (a.sortOrder ?? 999) - (b.sortOrder ?? 999);
    });

  if (asUIConfigs.length === 0) {
    return null;
  }

  return (
    <Flex
      flexDirection="column"
      rowGap={7}
    >
      {asUIConfigs.map(attributeUIConfig => {
        return (
          <AttributeSelector
            getAttribute={getAttribute}
            getFullState={getFullState}
            key={attributeUIConfig.attributeId}
            attributeId={attributeUIConfig.attributeId}
            product={activeProduct}
            priceCalculator={priceCalculator}
            {...props}
          />
        );
      })}
    </Flex>
  );
};
